import { render, staticRenderFns } from "./configuration-archive-levels.vue?vue&type=template&id=3526cfc5&"
import script from "./configuration-archive-levels.ts?vue&type=script&lang=ts&"
export * from "./configuration-archive-levels.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-archive-levels.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports